<input type="text"
            [(ngModel)]="filter.viewModel.value.value"
            (change)="filter.onChange()"
            (focus)="filter.focusInput$.next()"
            (keydown)="advancedSearchBox.keydown($event,filter.viewModel)" 
            autosize 
            [placeholder]="filter.viewModel.placeholder | translate"
            #inputRef
            class="as-text-input"
            />